const state = {
  userData: null,
  devTimestamp: null,
  locale: 'ko'
}

const getters = {
  userData: state => state.userData,
  devTimestamp: state => state.devTimestamp,
  locale: state => state.locale
}

const mutations = {
  setUserData (state, data) {
    state.userData = data
  },
  setDevTimestamp (state, payload) {
    state.devTimestamp = payload
  },
  setLocale (state, payload) {
    state.locale = payload
  }
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
